import $ from "jquery"
import request_body from './request_body';

const PATCH_URL = "https://update.buercamp.com";
// const PATCH_URL = "http://127.0.0.1:8060";


// function login_request(path, params, contentType) {
//     if (contentType == "application/json") {
//         params = JSON.stringify(params)
//     }
//     return new Promise((resolve, reject)=>{
//         let vo = {
//             url: request_body.login_url + path,
//             type: "POST",
//             timeout: 600000,
//             headers: {  },
//             data: params,
//             success: (data) => {
//                 resolve(data);
//             },
//             error: (e) => {
//                 console.log(e.statusCode)
//                 if (e.status == 401) {
//                     window.location.href = "/login"
//                 }
//                 reject(e.responseJSON)
//             }
//         }
//         if (contentType != null) {
//             vo.contentType = contentType;
//         }
//         // if (request_body.token != null && request_body.token != "" && path != "/login/auth") {
//         //     vo.headers.token = request_body.token;
//         // }
//         if (request_body.token != null && request_body.token != "") {
//             vo.headers.Authorization = `${request_body.token}`;
//         }
//         $.ajax(vo) 
        
//     })
// }

function request(path, params, contentType) {
    if (window.request_host== null || window.request_host== "") {
        window.location.href = "/login"
    }

    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    
    return new Promise((resolve, reject)=>{
        let vo = {
            url: window.request_host+ path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(data);
            },
            error: (e, status, error) => {
                console.log(e, status, error)
                if (e.status == 401) {
                    window.location.href = "/admin_login"
                    return;
                }
                reject(e.responseJSON)
            },
            // statusCode: {
            //     401: function() {
            //         window.location.href = "/login"
            //     }
            // }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        // if (request_body.token != null && request_body.token != "" && path != "/login/auth") {
        //     vo.headers.token = request_body.token;
        // }
        // console.log(request_body.token)

        if (request_body.token != null && request_body.token != "") {
            vo.headers.Authorization = `${request_body.token}`;
        }
        $.ajax(vo) 
        
    })
}

function request_blob(path, params, contentType) {
    if (window.request_host== null || window.request_host== "") {
        window.location.href = "/login"
    }

    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    
    return new Promise((resolve, reject)=>{
        let vo = {
            url: window.request_host+ path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            xhrFields: {
                responseType: 'blob'
            },
            data: params,
            success: (data) => {
                resolve(data);
            },
            error: (e, status, error) => {
                console.log(e, status, error)
                if (e.status == 401) {
                    window.location.href = "/admin_login"
                    return;
                }
                reject(e.responseJSON)
            },
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        if (request_body.token != null && request_body.token != "") {
            vo.headers.Authorization = `${request_body.token}`;
        }
        $.ajax(vo) 
        
    })
}


function patch_request(path, params, contentType) {
    return new Promise((resolve, reject)=>{
        let vo = {
            url: window.update_host + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(JSON.parse(data));
            },
            error: (e, status, error) => {
                console.log(e, status, error)
                if (e.status == 401) {
                    window.location.href = "/admin_login"
                    return;
                }
                reject(e.responseJSON)
            },
        }
        if (contentType != null) {
            vo.contentType = contentType;
            if (contentType == "application/json") {
                vo.data = JSON.stringify(params)
            }
        }
        
        if (request_body.token != null && request_body.token != "") {
            vo.headers.Authorization = `${request_body.token}`;
        }
        $.ajax(vo) 
        
    })
}

function patch_get(path, params, contentType) {
    return new Promise((resolve, reject)=>{
        let vo = {
            url: window.update_host + path,
            type: "GET",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(JSON.parse(data));
            },
            error: (e, status, error) => {
                console.log(e, status, error)
                if (e.status == 401) {
                    window.location.href = "/admin_login"
                    return;
                }
                reject(e.responseJSON)
            },
        }
        if (contentType != null) {
            vo.contentType = contentType;
            if (contentType == "application/json") {
                vo.data = JSON.stringify(params)
            }
        }
        
        if (request_body.token != null && request_body.token != "") {
            vo.headers.Authorization = `${request_body.token}`;
        }
        $.ajax(vo) 
        
    })
}

function ad_request(path, params, contentType) {
    if (window.request_host == null || window.request_host == "") {
        window.location.href = "/login"
    }

    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    
    return new Promise((resolve, reject)=>{
        let vo = {
            url: window.ad_host + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(data);
            },
            error: (e) => {
                console.log(e)
                if (e.status == 401) {
                    window.location.href = "/login"
                }
                resolve({err: -100})
            }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        
        if (request_body.token2 != null && request_body.token2 != "") {
            vo.headers.token = `${request_body.token2}`;
        }
        $.ajax(vo) 
        
    })
}
//     https://game.buercamp.com
// }

export {
    request, request_blob, patch_request, patch_get, ad_request, PATCH_URL
}